var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniEdificio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M30.14 14.76h-5.9v-5.9c0-.475-.385-.86-.86-.86H9.86c-.475 0-.86.385-.86.86v20.28c0 .475.385.86.86.86h20.28c.475 0 .86-.385.86-.86V15.62c0-.475-.385-.86-.86-.86zM10.72 9.72H22.52V28.28H10.719V9.72zm13.52 18.562h5.042V16.48H24.24v11.802zM15.79 12.24c0 .474-.385.859-.86.859h-1.69c-.474 0-.859-.385-.859-.86 0-.474.385-.859.86-.859h1.69c.474 0 .86.385.86.86zm-.86 5.93c.475 0 .86-.385.86-.86s-.385-.86-.86-.86h-1.69c-.474 0-.859.385-.859.86s.385.86.86.86h1.69zm.86 4.21c0 .475-.385.86-.86.86h-1.69c-.474 0-.859-.385-.859-.86 0-.474.385-.86.86-.86h1.69c.474 0 .86.386.86.86zM20 13.1c.475 0 .86-.385.86-.86 0-.474-.385-.859-.86-.859h-1.69c-.475 0-.86.385-.86.86 0 .474.385.859.86.859H20zm.86 4.211c0 .475-.385.86-.86.86h-1.69c-.475 0-.86-.385-.86-.86s.385-.86.86-.86H20c.475 0 .86.385.86.86zM20 23.24c.475 0 .86-.385.86-.86 0-.474-.385-.86-.86-.86h-1.69c-.475 0-.86.386-.86.86 0 .475.385.86.86.86H20zM25.056 19c0-.475.385-.86.86-.86h1.69c.474 0 .859.385.859.86s-.385.86-.86.86h-1.69c-.474 0-.859-.385-.859-.86zm.86 2.52c-.475 0-.86.386-.86.86 0 .475.385.86.86.86h1.69c.474 0 .859-.385.859-.86 0-.474-.385-.86-.86-.86h-1.69z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniEdificio);
export default __webpack_public_path__ + "static/media/icon_mini_edificio.add6732ac3dd61adf791441a4f3ca9c9.svg";
export { ForwardRef as ReactComponent };